import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/marketingToolsApi'
import indexStore from '../Tabs/store'
import { message, Modal } from 'hljd'
import { PRIVILEGE_ORDER_REFUND } from '@constant'

const confirm = Modal.confirm

class Store {
  @observable list = []
  @observable ids = []
  @observable status
  @observable reason

  @action
  getStatus = async () => {
    let { data } = await Api.record_list()
    runInAction(() => {
      this.status = data[2].status
    })
  }

  @action
  getPromise = async () => {
    let {
      data: { option_list, reason }
    } = await Api.current_list({ id: PRIVILEGE_ORDER_REFUND })
    runInAction(() => {
      this.list = option_list
      this.reason = reason

      this.ids = option_list.map(({ id, status }) => {
        return { id, status }
      })
    })
  }

  @action
  changeCheck = (id, index) => e => {
    Object.assign(this.ids[index], {
      status: e.target.checked ? 1 : 0
    })
  }

  @action
  savePromise = async () => {
    const { ids, status } = this

    let _ids = []
    ids.forEach(({ id, status }) => {
      if (status == 1) {
        _ids.push(id)
      }
    })

    if (_ids.length < 1) {
      return message.warning('请至少选择1个！')
    }

    let params = {
      grade_privilege_id: PRIVILEGE_ORDER_REFUND,
      ids: _ids,
      status: 1
    }

    let apiName
    if (status == 0) {
      apiName = Api.add(params)
    } else {
      apiName = Api.edit(params)
    }

    let { success } = await apiName

    if (success) {
      message.success('操作成功！')
      window.location.href = `#/localMerchant/marketingTools?key=${PRIVILEGE_ORDER_REFUND}`
    }
  }

  @action
  closePromise = () => {
    let params = {
      grade_privilege_id: PRIVILEGE_ORDER_REFUND,
      status: 0
    }

    confirm({
      title: '确定要关闭订单可退',
      onOk: async () => {
        let { success } = await Api.edit(params)
        if (success) {
          message.success('操作成功！')
          indexStore.getTabInfo()
          indexStore.getCurrentList(PRIVILEGE_ORDER_REFUND)
        }
      }
    })
  }
}
export default new Store()
